import { render } from "./InstructionForm.vue?vue&type=template&id=5b17c38e"
import script from "./InstructionForm.vue?vue&type=script&lang=js"
export * from "./InstructionForm.vue?vue&type=script&lang=js"

import "./InstructionForm.vue?vue&type=style&index=0&id=5b17c38e&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__